import {UrlGeneratorService} from "external-services/url-generator-service/UrlGenerator.service";
import ObjectCopyService from "external-services/object-copy-service/index";
import NetworkConnectionService from 'external-services/network-connection-service/index';
import GeneralSettingsService from "external-services/general-settings-service/generalSettings.service";
import BookingsAffectedService from "app/services/bookingsAffected/bookingsAffected.service";
import AdminService from "external-services/diary-admin-service/admin.service";
import PhoneNumberService from "app/services/phoneNumber/phoneNumber.service";
import EventsService from 'app/services/events/events.service';
import CompareObjectsService from "external-services/compare-objects-service/CompareObjects";
import moment from "moment";
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";
import { CustomerGeneratorService } from "external-services/customer-generator-service";
import {ServiceEventType} from "app/app.types";
import LayoutsService from 'external-services/layouts-service/layouts.service';
import EventsLookupService from "external-services/events-lookup-service";
import CustomIntervalsService from "app/services/customIntervals/customIntervals.service";
import CustomerLookupService from 'external-services/customer-lookup-service';
import {WHOLE_NUMBER_REGEX} from "appRoot/app.constants";
import {paymentProviderTypeUppercase} from 'shared-types/WidgetTypes';
import DateUtilsService from 'external-services/date-utils-service';

/**
 * Gets used on route 'settings.events.edit'
 */

const NS = 'EventEditorCtrl'; // jshint ignore:line

export default function EventEditorCtrl(
  $q, $rootScope, $log, $scope, $state, $filter, $interpolate, $stateParams, $mdDialog,
  $mdToast, $window, pouchService, scheduleService, appConstants, unregister
) {
  "ngInject";

  const vm = this;
  var saveEvent;
  var orgEvent;
  var listeners;

  var modifiedValue = [];

  // lifecycle hook
  vm.$onInit = function () {

    //-- define public properties
    vm.paymentTypes = appConstants.Payment.PaymentTypes;
    vm.eventObj = {};
    vm.customer = null;
    vm.selectedIndex = 0;
    vm.SECTION_NOT_USED = 'not-used';
    vm.SECTION_CLOSED = 'closed';
    vm.bookingIntervals = scheduleService.bookingIntervals;
    vm.minBookingDuration = 30;
    vm.privateFunctionAllowed = window.config.privateFunctions;
    vm.focusEventDate = false;
    vm.maxPeoplePerOnlineBooking = AdminService.getVenue().maxPeoplePerOnlineBooking || 9999;
    vm.WHOLE_NUMBER_REGEX = WHOLE_NUMBER_REGEX;

    // states
    vm.LOADING = 1;
    vm.ENTER = 0;
    vm.ERROR = 3;
    vm.ERROR_OVERLAP = 5;
    vm.CONFLICTS = 4;
    vm.state = vm.LOADING;
    vm.mode = $state.current.mode || 'new';
    vm.maxDate = '9999-12-31';

    //-- define public methods
    vm.cancel = cancel;
    vm.save = save;
    vm.isOffline = true;
    vm.getCustomer = getCustomer;
    vm.dateChange = dateChange;
    vm.printConflicts = printConflicts;
    vm.account = AdminService.getAccount();
    vm.venue = AdminService.getVenue();
    vm.theme = AdminService.getThemeValues();
    vm.nextTab = nextTab;
    vm.previousTab = previousTab;
    vm.backOnError = backOnError;
    vm.formatNumber = (...args) => PhoneNumberService.formatNumber(...args);
    vm.sectionChange = sectionChange;
    vm.updateCustomIntervals = updateCustomIntervals;

    vm.isUsingWidgetV2 = vm.theme.widgetVersion === 2;
    vm.widgetUrl = vm.isUsingWidgetV2 ? $window.config.widgetV2Url : $window.config.widgetUrl;
    vm.staffNameRequired = false;
    vm.showStaffName = false;
    vm.originalEvent = null;
    vm.isNoPayment = true;
    vm.paymentBookingOptionLabel = "Payments & Booking Options";

    //-- destory
    listeners = [];
    listeners.push($scope.$watch('vm.eventObj.paymentDetails.paymentType', generateBookingUrl));
    listeners.push($scope.$watch(() => vm.eventObj.eventType, typeChange));
    listeners.push($scope.$watch(() => vm.eventObj.paymentDetails?.paymentType, checkForNoPayment));
    listeners.push($scope.$on('$destroy', () => unregister(listeners)));

    init();
  }; // end $onInit

  function init() {

    getGeneralSettings();

    if (!$stateParams.id) {
      $state.go('settings.events');
      return;
    }

    if ($state.current.mode === 'duplicate') {
      vm.mode = 'duplicate';
    } else {
      vm.mode = $stateParams.id === 'new' ? 'new' : 'edit';
    }


    if (vm.mode === 'new') {
      vm.eventObj = {
        eventType: ServiceEventType.Event,
        description: ''
      };
      vm.privateFunction = false;
      getSections();
      getCustomer(true);
      vm.state = vm.ENTER;
      return;
    }

    vm.state = vm.LOADING;
    getEvent($stateParams.id);

  }

  function getGeneralSettings()
  {
    GeneralSettingsService.get().then(function (settings) {

      if (vm.mode === 'new' || vm.mode === 'duplicate') {
        if(settings.staffRequiredCreateEvent)
        {
          vm.showStaffName = true;
          vm.staffNameRequired = true;
        }
      }
      else if(settings.staffRequiredEditEvent)
      {
        vm.showStaffName = settings.staffRequiredEditEvent;
      }


    });
  }

  function updateCustomIntervals(intervals) {
    if (vm.eventObj.enableCustomPaxPerIntervals) {
      vm.eventObj.intervalsCustom = CustomIntervalsService.getCustomIntervalsForService(vm.eventObj, intervals);
    }
  }

  $rootScope.$on('dateChangedInDirective', function (evt, data) { // To get the changed date event from the DateTimePopUp Directive.
    if (vm.eventObj && (data === 'startTime' || data === 'endTime')) {
      updateCustomIntervals(vm.eventObj.boookingInterval)
    }
  });

  function nextTab() {
    vm.selectedIndex++;
  }

  function previousTab() {
    vm.selectedIndex--;
  }

  function printConflicts() {
    window.print();
  }

  function updateOfflineStatus() {
    vm.isOffline = AdminService.getVenue().isOnlineCustomersEnabled && !NetworkConnectionService.isOnline();
  }

  // NBI-7051
  // Update tab label when event type is private function
  function updatePaymentLabel(eventType) {
    if (eventType === ServiceEventType.PrivateFunction) {
      vm.paymentBookingOptionLabel = "Payments"
    }

    if (eventType === ServiceEventType.Event) {
      vm.paymentBookingOptionLabel = "Payments & Booking Options"
    }
  }

  function typeChange() {
    updateOfflineStatus();
    updatePaymentLabel(vm.eventObj.eventType);
    if (vm.mode === 'new' && vm.eventObj.eventType === ServiceEventType.PrivateFunction && vm.isOffline) {
      // show popup about offline
      $mdDialog.show(
        $mdDialog.alert()
          .clickOutsideToClose(true)
          .title('You are offline')
          .textContent('You can\'t create private functions while offline. Check your connection and try again.')
          .ariaLabel('Error, no internet connection.')
          .ok('Ok')
      );
      vm.eventObj.eventType = ServiceEventType.Event;
    }
    vm.privateFunction = (vm.eventObj.eventType === ServiceEventType.PrivateFunction);

    if (vm.privateFunction) {
      vm.eventObj.lastBookingTime = null;
      getCustomer(!vm.customer && !vm.eventObj.customerId);
    } else {
      vm.customer = null;
    }
    generateBookingUrl();
  }

  function dateChange() {
    if (vm.eventObj.date) {
      var times = ['startTime', 'firstBookingTime', 'lastBookingTime', 'endTime'];
      for (var i = times.length - 1; i >= 0; i--) {
        var time = vm.eventObj[times[i]];
        if (time) {
          time.setFullYear(vm.eventObj.date.getFullYear());
          time.setMonth(vm.eventObj.date.getMonth());
          time.setDate(vm.eventObj.date.getDate());
          if (DateUtilsService.isTimeSmallerThanDayEnd(time)) {
            time.setDate(vm.eventObj.date.getDate() + 1);
          } else {
            time.setDate(vm.eventObj.date.getDate());
          }
        }
      }
    }
  }

  function getEvent(id) {
    EventsLookupService.getById(id).then(function (eventObj) {
      orgEvent = ObjectCopyService.angularSafeCopy(eventObj);
      if (vm.mode === 'duplicate') {
        delete eventObj._id;
        delete eventObj._rev;
        eventObj.date = null;
        vm.selectedIndex = 1;
        vm.focusEventDate = true;
      }
      if (!eventObj.description) {
        eventObj.description = '';
      }
      if (!eventObj.eventType) {
        eventObj.eventType = (eventObj.paymentDetails.paymentType === appConstants.Payment.PaymentTypes.FunctionPayment) ? ServiceEventType.PrivateFunction : ServiceEventType.Event;
      }
      vm.eventObj = eventObj;
      if (vm.eventObj.people) {
        vm.eventObj.people = Number(vm.eventObj.people);
      }

      getSections();
      getCustomer();
      generateBookingUrl();

      vm.eventObj.staffName = '';
      vm.state = vm.ENTER;
    }).catch(function (err) {
      $log.error('error getting event', id, err);
    });
  }

  function getCustomer(isNew = false) {
    updateOfflineStatus();
    if(isNew) {
      vm.customer = CustomerGeneratorService.getEmptyCustomer(null);
      vm.customer.phone = null;
    } else {
      // try and get the customer object if it is needed, otherwise resolve
      if (!vm.isOffline && !vm.customer && vm.eventObj.eventType === 'PrivateFunction' && vm.eventObj.customerId) {
        CustomerLookupService.getById(vm.eventObj.customerId).then(function (customer) {
          vm.customer = customer;
        }).catch(() => {
          updateOfflineStatus();
        });
      }
    }
  }

  function getSections() {
    SectionLookupService.getSections().then(function (sections) {
      vm.sections = $filter('orderBy')(sections, 'order');
      var sectionLookUp = {};
      for (var i = sections.length - 1; i >= 0; i--) {
        var section = sections[i];
        sectionLookUp[section._id] = section;
      }
      vm.sectionLookUp = sectionLookUp;
      getLayouts();
    }).catch(function (err) {
      $log.error('error getting sections', err);
    });
  }

  function getLayouts() {
    LayoutsService.getAllLayouts().then(function (layouts) {
      var sectionLayouts = {};
      for (var i = layouts.length - 1; i >= 0; i--) {
        var layout = layouts[i];
        var idParts = layout._id.split('_');
        idParts.pop();
        layout.layoutId = idParts.join('_');
        if (!sectionLayouts[layout.sectionId]) {
          sectionLayouts[layout.sectionId] = [];
        }
        sectionLayouts[layout.sectionId].push(layout);
      }
      vm.sectionLayouts = sectionLayouts;
      if ($stateParams.id !== 'new') {
        parseEvent();
      }
    }).catch(function () {
      $log.error('Failed to get all layouts');
    });
  }

  function parseEvent() {
    vm.eventObj.selectedLayouts = {};
    for (var s = vm.eventObj.sectionLayouts.length - 1; s >= 0; s--) {
      var sectionLayout = vm.eventObj.sectionLayouts[s];
      vm.eventObj.selectedLayouts[sectionLayout.sectionId] = sectionLayout.layoutId;
    }

    for (var f = vm.sections.length - 1; f >= 0; f--) {
      var section = vm.sections[f];
      if (vm.eventObj.selectedLayouts[section._id] === null) {
        vm.eventObj.selectedLayouts[section._id] = vm.SECTION_CLOSED;
      } else if (!vm.eventObj.selectedLayouts[section._id]) {
        vm.eventObj.selectedLayouts[section._id] = vm.SECTION_NOT_USED;
      }
    }

    vm.originalEvent = ObjectCopyService.angularSafeCopy(vm.eventObj);
    vm.state = vm.ENTER;
  }

  function cancel() {
    $state.go('settings.events');
  }

  function save() {
    dateChange();

    var isValid = $scope.eventForm.$valid && validateCustomer();

    if(vm.originalEvent)
    {

      // We are manually updating values so no need to compare in the comparision method.
      var ignoreList = ["sectionLayouts", "selectedLayouts", "staffName"];
      var changedValues = CompareObjectsService.computeObjectDifference (vm.originalEvent, vm.eventObj, '', true, ignoreList)

      if(changedValues.length !== 0)
      {
        if (vm.showStaffName && !vm.eventObj.staffName) {
          vm.staffNameRequired = true;
          isValid = false;
        }
        else
        {
          for(const changes of changedValues)
          {
            CompareObjectsService.addToArray(modifiedValue, changes.property, changes.originalValue, changes.newValue, changes.operation, true);
          }
        }
      }
    }
    else if (isValid)
    {
      populateLogInformation();
    }

    if (isValid) {
      vm.state = vm.LOADING;
      //check the booking does not over lap other events
      checkOverLap(vm.eventObj).then(function () {
        // save
        return doSave();
      }).then(function () {
        vm.state = vm.ENTER;
        $mdToast.show(
          $mdToast.simple()
            .content('Event Saved')
            .position('bottom right')
            .theme('saved')
            .hideDelay(3000)
        );
        BookingsAffectedService.checkEvent(saveEvent, orgEvent).then(function (effectedBookings) {
          if (!effectedBookings || (effectedBookings.length === 0)) {
            // There are not conflicts
            $state.go('settings.events');
          } else {
            vm.state = vm.CONFLICTS;
            vm.bookingConflicts = effectedBookings;
            filterConflicts();
            listeners.push($rootScope.$on('booking-edited', reCheckConfict));
            listeners.push($rootScope.$on('booking-new', reCheckConfict));
          }
        });
      }).catch(function (err) {
        if (err) {
          if (err.type === 'overlap') {
            vm.errorMsg = 'Your event overlaps with the ' + err.overlapEvent.name;
            vm.state = vm.ERROR_OVERLAP;
            return;
          } else if (err.name === 'conflict') {
            vm.errorMsg = `This event has been saved elsewhere while you've had it open and is no longer the most recent data. Your changes
                haven't been saved. Please reload this event before making your change again.`;
          } else {
            console.error(err);
          }
        }

        // the block failed to save
        vm.state = vm.ERROR;
      });

    } else {
      // check if customer is valid
      if (!validateCustomer()) {
        vm.selectedIndex = 4;
      }

      // check if other forms are valid
      var forms = [$scope.eventForm.info, $scope.eventForm.time, $scope.eventForm.details, $scope.eventForm.layouts, $scope.eventForm.payment];
      for (var i = 0; i < forms.length; i++) {
        if (!forms[i].$valid) {
          vm.selectedIndex = i;
          break;
        }
      }
      vm.displayErrors = true;
    }
  }

  function validateCustomer() {
    const isVenueHasEwayPayment = vm.venue.paymentSettings?.paymentProvider === paymentProviderTypeUppercase.Eway;
    if (vm.customer) {
      if (isVenueHasEwayPayment && !vm.isNoPayment) {
        if (vm.customer.firstName && vm.customer.lastName && (vm.customer.email || vm.customer.phone)) {
          return true;
        }
      } else {
        if ((vm.customer.lastName || vm.customer.firstName) && (vm.customer.email || vm.customer.phone)) {
          return true;
        }
      }
    } else {
      return true;
    }
    return false;
  }

  function checkOverLap(newEvent) {
    return $q(function (resolve, reject) {
      EventsService.getEventsOnDate(vm.eventObj.date).then(function (eventsOnDate) {
        var overlap = false;
        var overlapEvent;

        if (vm.eventObj._id) {
          for (var i = eventsOnDate.length - 1; i >= 0; i--) {
            if (eventsOnDate[i]._id === vm.eventObj._id) {
              eventsOnDate.splice(i, 0);
              break;
            }
          }
        }

        eventsOnDate.push(newEvent);

        if (eventsOnDate && eventsOnDate.length) {
          for (var j = eventsOnDate.length - 1; j >= 0; j--) {
            var compareEvent = eventsOnDate[j];
            var startA = vm.eventObj.startTime.getTime(),
              endA = vm.eventObj.endTime.getTime(),
              startB = compareEvent.startTime.getTime(),
              endB = compareEvent.endTime.getTime();

            if (startA < endB && endA > startB) {
              // times overlap
              if (compareEvent._id !== vm.eventObj._id) {
                var compareEventSectionIds = compareEvent.sectionLayouts.map(function (item) {
                  return item.sectionId;
                });
                for (var sectionId in vm.eventObj.selectedLayouts) {
                  if (compareEventSectionIds.indexOf(sectionId) !== -1 && vm.eventObj.selectedLayouts[sectionId] !== 'not-used') {
                    overlap = true;
                    overlapEvent = compareEvent;
                    break;
                  }
                }
              }
            }
          }
        }

        if (!overlap) {
          // there are no other events that overlap on this event
          resolve();
        } else {
          // there are other events that overlap on this event
          reject({
            type: 'overlap',
            overlapEvent: overlapEvent
          });
        }
      });
    });
  }

  function doSave() {

    // We will have difference in values only if an event is being edited, incase of new event, originalEvent will be null

    return $q(function (resolve, reject) {
      saveEvent = ObjectCopyService.angularSafeCopy(vm.eventObj);

      if (vm.privateFunction) {
        saveEvent.online = false;
      }

      // build sectionLayouts
      var sectionLayouts = [];
      for (var sectionId in saveEvent.selectedLayouts) {
        var layoutId = saveEvent.selectedLayouts[sectionId];
        if (layoutId === vm.SECTION_CLOSED) {
          sectionLayouts.push({
            layoutId: null,
            sectionId: sectionId
          });
        } else if (layoutId !== vm.SECTION_NOT_USED) {
          sectionLayouts.push({
            layoutId: layoutId,
            sectionId: sectionId
          });
        }
      }

      saveEvent.sectionLayouts = sectionLayouts;
      delete saveEvent.selectedLayouts;

      EventsService.save(saveEvent, vm.customer).then(function () {
        // Clear Schedule Cache
        scheduleService.clearLookUps();

        resolve();

        // Removing Manju Changes done related to ChangeLog feature - NBI-4368-Removing-manju-changelog
        // if (modifiedValue.length > 0) {
        //   ChangeLoggerService.save(modifiedValue, 'changelog_events', vm.eventObj.staffName, saveEvent.name);
        // }

        modifiedValue = [];
      }).catch(err => {
        reject(err);
      });
    });
  }

  function reCheckConfict() {
    BookingsAffectedService.checkEvent(saveEvent, orgEvent).then(function (effectedBookings) {
      vm.bookingConflicts = effectedBookings;
      filterConflicts();
    });
  }

  function generateBookingUrl() {
    vm.url = UrlGeneratorService.generateEventUrl(vm.eventObj.date, vm.eventObj._id, vm.privateFunction);
  }

  function filterConflicts() {
    if (vm.bookingConflicts && vm.bookingConflicts.length) {
      vm.timeConflicts = $filter('filter')(vm.bookingConflicts, {
        timeEffected: true
      });
      vm.tableConflicts = $filter('filter')(vm.bookingConflicts, {
        timeEffected: false
      });
      vm.serviceConflict = $filter('filter')(vm.bookingConflicts, {
        serviceEffected: false
      });
    } else {
      vm.timeConflicts = [];
      vm.tableConflicts = [];
      vm.serviceConflict = [];
    }
  }

  function backOnError() {
    vm.state = vm.ENTER;
  }

  function populateLogInformation()
  {
    CompareObjectsService.addToArray(modifiedValue, 'Event', '', vm.eventObj.name, 'New');
    CompareObjectsService.addToArray(modifiedValue, 'EventType', '', vm.eventObj.eventType, 'New');
    CompareObjectsService.addToArray(modifiedValue, 'StartDate', '', moment(vm.eventObj.date).format('DD MMM YY'), 'New');
    CompareObjectsService.addToArray(modifiedValue, 'StartTime', '', moment(vm.eventObj.startTime).format('h:mma'), 'New');

    if(vm.eventObj.paymentDetails)
    {
      CompareObjectsService.addToArray(modifiedValue, 'PaymentType', '', vm.eventObj.paymentDetails.paymentType, 'New');
    }
    else
    {
      CompareObjectsService.addToArray(modifiedValue, 'PaymentType', '', 'None', 'New');
    }

    // Set staffname to required if any of the section values were changed. Need to manually set it here as
    // we ignore this array value comparision in our generic comparision
    if (vm.showStaffName) {
      vm.staffNameRequired = true;
    }
  }

  function sectionChange(layoutId, sectionId, sectionName)
  {
     if(vm.sectionLayouts[sectionId])
     {
       const layout = vm.sectionLayouts[sectionId].find(x => x.layoutId == layoutId);

       if (layout) {
         CompareObjectsService.addToArray(modifiedValue, `section ${sectionName}`, '', layout.name, 'Change');
       } else {
         CompareObjectsService.addToArray(modifiedValue, `section ${sectionName}`, '', layoutId, 'Change');
       }

     }

     // Set staffname to required if any of the section values were changed. Need to manually set it here as
     // we ignore this array value comparision in our generic comparision
    if (vm.showStaffName) {
      vm.staffNameRequired = true;
    }


  }

  function checkForNoPayment() {
      vm.isNoPayment = vm.eventObj?.paymentDetails?.paymentType === appConstants.Payment.PaymentTypes.NoPayment;
  }

}
